/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';

import './add-photo.scss';
import style from './style.module.scss';
import Icon from '@components/icon-component';

const PhotoUI = ({ selectedFile, deleteImage, singleImage }) => {
  const [preview, setPreview] = useState();
  const [isHeicFile, setIsHeicFile] = useState(false);

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      setIsHeicFile(false);
      return;
    }

    // Check if file is HEIC/HEIF
    const fileExtension = selectedFile?.name?.split('.')?.pop()?.toLowerCase();

    const isHeic =
      selectedFile?.type === 'image/heic' ||
      selectedFile?.type === 'image/heif' ||
      fileExtension === 'heic' ||
      fileExtension === 'heif';

    setIsHeicFile(isHeic);

    if (isHeic) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);

    // Cleanup function to revoke blob URL
    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [selectedFile]);

  useEffect(() => {
    return () => {
      if (preview && preview.startsWith('blob:')) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  return (
    <div className={`${style.photoForm} ${!singleImage && style.multipleImagesPhotoForm}`}>
      <div
        className={`${singleImage ? style.selectedImageSingle : style.selectedImageMultiple} ${
          isHeicFile && style.heicBoxHeight
        }`}
      >
        {isHeicFile ? (
          <div className={style.heicPlaceholder}>
            <p className={style.heicSubText}>
              Some high efficiency photos cannot be previewed. Once synced, they will be converted
              for display in desktop Oplii.
            </p>
          </div>
        ) : (
          <img src={preview} className={style.imgIcon} />
        )}

        <Icon
          name={'delete-image-icon'}
          alt=""
          className={style.positionIcon}
          onClick={deleteImage}
        />
      </div>
    </div>
  );
};

export default PhotoUI;
